import * as React from "react";
import {
  Typography,
  Box,
  Container,
  TextField,
  Button,
  Avatar,
  Select,
  MenuItem,
  InputLabel,
  FormHelperText,
  FormControl,
  CircularProgress,
  Chip,
  Grid,
  Checkbox,
  Paper,
  Stack,
} from "@mui/material";
import { connect } from "react-redux";
import { useNavigate, useParams, Link as RouterLink } from "react-router-dom";
import PaymentIcon from "@mui/icons-material/Payment";
import ScheduleSendIcon from "@mui/icons-material/ScheduleSend";
import SendIcon from "@mui/icons-material/Send";
import ReactFileReader from 'react-file-reader';
import {
  MainInput,
  MainInputLabel,
  SecStyledInput,
  StyledInput,
  TerInput,
  centered_flex_box,
  main_button,
  reject_button,
  sec_button,
} from "../../app/components/Styles";
import { getEvent } from "../../app/store/actions/eventActions";
import { addToCart, checkoutTransfer, requestTicket } from "../../app/store/actions/userActions";
import moment from "moment";
import LocationOn from "@mui/icons-material/LocationOn";
import DirectionsIcon from "@mui/icons-material/Directions";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import { isMobile } from "react-device-detect";
import { Image, notification } from "antd";
import MuiPhoneNumber from "material-ui-phone-number";
import ReactGA from "react-ga4";
import { AccountBalance, Upload, CalendarMonth, AccessTime } from "@mui/icons-material";
import { uploadFile } from "../../core/aws";
import { config } from "../../app/config";
import { motion } from "framer-motion";
import { MarketingPage, MarketingCard, MarketingButton } from "../../app/components/marketing";
import {
  marketingColors,
  marketingFonts,
  sectionLabelSx,
  eventFormSectionSx,
  eventSurfacePaperSx,
  eventSectionTitleSx,
  eventOutlinedButtonSx,
  eventContainedButtonSx,
} from "../../app/components/tickitMarketingTheme";

export const SingleEvent = ({
  getEvent,
  events,
  event,
  user,
  addToCart,
  requestTicket,
  checkoutTransfer,
}) => {
  window.Buffer = window.Buffer || require("buffer").Buffer;
  const modernFieldSx = {
    "& .MuiInputLabel-root": {
      color: marketingColors.gray600,
      fontWeight: 500,
      fontFamily: marketingFonts.body,
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: marketingColors.p700,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 2,
      backgroundColor: "#ffffff",
      color: "#1f1f1f",
      transition: "all 0.2s ease",
      "& input": {
        color: "#1f1f1f",
      },
      "& input.Mui-disabled": {
        WebkitTextFillColor: "#1f1f1f",
        color: "#1f1f1f",
        opacity: 1,
      },
      "& textarea": {
        color: "#1f1f1f",
      },
      "& textarea.Mui-disabled": {
        WebkitTextFillColor: "#1f1f1f",
        color: "#1f1f1f",
        opacity: 1,
      },
      "&.Mui-disabled": {
        backgroundColor: "#f6f7fb",
      },
      "& fieldset": {
        borderColor: "#a7abc0",
        borderWidth: "1.5px",
      },
      "&:hover fieldset": {
        borderColor: "#7f859f",
        borderWidth: "1.5px",
      },
      "&.Mui-focused fieldset": {
        borderColor: marketingColors.p700,
        borderWidth: "2px",
      },
    },
    "& .MuiSelect-select": {
      color: "#1f1f1f",
      WebkitTextFillColor: "#1f1f1f",
    },
    "& .MuiSvgIcon-root": {
      color: marketingColors.gray500,
    },
  };

  const sectionCardSx = eventFormSectionSx;

  const phoneInputSx = {
    ...modernFieldSx,
    "& .MuiInputBase-input": {
      fontSize: { xs: "0.9rem", sm: "1rem" },
      letterSpacing: "0",
      paddingRight: "10px",
    },
    "& .MuiInputBase-input.Mui-disabled": {
      WebkitTextFillColor: "#1f1f1f",
      color: "#1f1f1f",
      opacity: 1,
      fontSize: { xs: "0.9rem", sm: "1rem" },
      letterSpacing: "0",
    },
    "& .MuiOutlinedInput-root": {
      ...modernFieldSx["& .MuiOutlinedInput-root"],
      "& .flag-dropdown": {
        borderRight: "1px solid #ececf3",
      },
    },
  };

  const navigate = useNavigate();
  const id = useParams().id;
  const [shop, setShop] = React.useState(false);
  const [amounts, setAmounts] = React.useState({});
  const [forMe, setforMe] = React.useState({});
  const [total, setTotal] = React.useState(0);
  const [category, setCategory] = React.useState("");
  const [categoryError, setCategoryError] = React.useState("");
  const [ticketPhone, setTicketPhone] = React.useState("");
  const [receipt, setReceipt] = React.useState(null)
  const handleAddReceipt = files => {
    let file = files[0]
    console.log(file)
    setReceipt(file)
  }

  const handleDeleteReceipt = () => {
    setReceipt(null);
  }

  React.useEffect(() => {
    getEvent({ eventId: id });
    ReactGA.send({ hitType: "pageview", page: `/event/${id}`, title: "Event" });
  }, []);

  React.useEffect(() => {
    const firstAvailableCategory = event?.categories?.find(
      (cat) => cat.available === "true"
    );
    if (!firstAvailableCategory) return;
    setCategory(firstAvailableCategory.category);
    setTotal(parseInt(firstAvailableCategory.price));
    setCategoryError("");
  }, [event]);

  const handleShop = () => {
    if (!user) {
      notification.info({
        message: "Please login or create an account to request a ticket",
      });
      navigate("/Login");
    } else {
      setShop(!shop);
    }
  };

  const handleAddToCart = async (ev) => {
    ev.preventDefault();
    const data = new FormData(ev.currentTarget);
    const items = [];
    let total = 0
    for (let key in amounts) {
      total += amounts[key]
    }
    for (let key in amounts) {
      if (amounts.hasOwnProperty(key) && amounts[key] > 0) {
        let userInfos = [];
        for (let i = 1; i <= total; i++) {
          let idx = i;
          let userInfo = {
            userId: forMe[i] ? user._id : undefined,
            name: forMe[i] ? user.name : data.get(`ticket-${idx}-name`),
            email: forMe[i] ? user.email : data.get(`ticket-${idx}-email`),
            phoneNumber: forMe[i]
              ? user.phoneNumber
              : data.get(`ticket-${idx}-mob`),
          };
          event?.moreInfo.map((info) => userInfo[info] = data.get(`ticket-${idx}-${info}`));
          console.log(idx, userInfo)
          userInfos.push(userInfo);
        }
        items.push({
          itemId: id,
          quantity: amounts[key],
          category: event?.categories[key].category,
          userInfos,
          price: amounts[key] * parseInt(event?.categories[key].price),
        });
      }
    }
    !event.byRequest && items.length > 0 && addToCart({ items, totalPrice: total }, navigate);
  };

  const handleTransfer = async (ev) => {
    ev.preventDefault();
    const data = new FormData(ev.currentTarget);
    const items = [];
    let total = 0
    for (let key in amounts) {
      total += amounts[key]
    }
    for (let key in amounts) {
      if (amounts.hasOwnProperty(key) && amounts[key] > 0) {
        let userInfos = [];
        for (let i = 1; i <= total; i++) {
          let idx = i;
          let userInfo = {
            userId: forMe[i] ? user._id : undefined,
            name: forMe[i] ? user.name : data.get(`ticket-${idx}-name`),
            email: forMe[i] ? user.email : data.get(`ticket-${idx}-email`),
            phoneNumber: forMe[i]
              ? user.phoneNumber
              : data.get(`ticket-${idx}-mob`),
          };
          event?.moreInfo.map((info) => userInfo[info] = data.get(`ticket-${idx}-${info}`));
          console.log(idx, userInfo)
          userInfos.push(userInfo);
        }
        items.push({
          itemId: id,
          quantity: amounts[key],
          category: event?.categories[key].category,
          userInfos,
          price: amounts[key] * parseInt(event?.categories[key].price),
        });
      }
    }
    let imageUrl;
    if (receipt) {
      imageUrl = await uploadFile(receipt)
    } else {
      notification.error({ message: "Please Upload Receipt" })
    }

    !event.byRequest && receipt && items.length > 0 && checkoutTransfer({ items, eventId: event._id, totalPrice: total, paymentUser: data.get('paymentUser'), receipt: imageUrl }, navigate);
    navigate("/events")
  };

  const handleRequestTicket = async (ev) => {
    ev.preventDefault();
    if (!category) {
      setCategoryError("Please select a category");
      return;
    }
    const data = new FormData(ev.currentTarget);
    let userInfo = {
      userId: forMe[0] ? user._id : undefined,
      name: forMe[0] ? user.name : data.get(`ticket-0-name`),
      email: forMe[0] ? user.email : data.get(`ticket-0-email`),
      phoneNumber: forMe[0] ? user.phoneNumber : (ticketPhone || data.get(`ticket-0-mob`)),
    };

    event?.moreInfo.map((info) => userInfo[info] = data.get(`ticket-0-${info}`));

    const creation = {
      userInfo,
      event: event._id,
      category,
      price: total,
    };

    requestTicket({ creation }, navigate);
  };

  const handleForMe = (e) => {
    const { name, checked } = e.target;
    setforMe({ ...forMe, [name]: checked });
  };

  const handleAmountChange = (e) => {
    const { name, value } = e.target;
    setAmounts({ ...amounts, [name.split("-")[1]]: parseInt(value) });
    let total = 0;
    for (let key in amounts) {
      if (amounts.hasOwnProperty(key) && key !== name.split("-")[1]) {
        let idx = key;
        total += parseInt(event?.categories[idx].price) * amounts[key];
      }
    }
    total += parseInt(event?.categories[name.split("-")[1]].price) * value;
    setTotal(total);
    console.log(total);
  };

  const handleCategoryChange = (e) => {
    const { value } = e.target;
    setCategory(value);
    setCategoryError("");
    let total = 0;
    for (let i = 0; i < event.categories.length; i++) {
      let singleCategory = event.categories[i];
      console.log(singleCategory);
      if (singleCategory.category === value) {
        total = singleCategory.price;
      }
    }
    setTotal(total);
  };

  const generateCategories = () => {
    var items = [];
    var categories = event?.categories;
    for (let i = 0; i < categories.length; i++) {
      let category = categories[i];
      if (category.available === "false") continue;
      items.push(
        <Paper 
          key={i}
          elevation={0}
          sx={{ 
            p: 2,
            borderRadius: "12px",
            backgroundColor: '#fff',
            border: `1px solid ${marketingColors.gray200}`,
            boxShadow: "0 2px 8px rgba(70,16,155,0.04)",
          }}
        >
          <Grid container alignItems="center" spacing={2}>
            <Grid item xs={12} sm={6}>
              <Typography sx={{ fontFamily: marketingFonts.display, fontWeight: 800, fontSize: "1rem", color: marketingColors.gray900 }}>
                {category.category} Category
              </Typography>
              <Typography variant="body2" sx={{ fontFamily: marketingFonts.body, color: marketingColors.gray500, mt: 0.5 }}>
                {category.price} EGP per ticket
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <Select
                  value={amounts[i] || 0}
                  onChange={(e) => handleAmountChange({ target: { name: `cat-${i}`, value: e.target.value } })}
                  sx={modernFieldSx}
                >
                  {[0, 1, 2, 3, 4, 5].map((num) => (
                    <MenuItem key={num} value={num} sx={{ color: '#1f1f1f' }}>{num} tickets</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Paper>
      );
    }
    return items;
  };

  const generateDetails = () => {
    var items = [];
    var idx = 0;
    for (let key in amounts) {
      if (amounts.hasOwnProperty(key)) {
        let number = amounts[key];
        for (let i = 0; i < number; i++) {
          idx++;
          items.push(
            <Paper 
              key={idx}
              elevation={0}
              sx={{ 
                p: 2,
                borderRadius: "12px",
                backgroundColor: '#fff',
                border: `1px solid ${marketingColors.gray200}`,
                boxShadow: "0 2px 8px rgba(70,16,155,0.04)",
              }}
            >
              <Stack spacing={2}>
                <Typography sx={{ fontFamily: marketingFonts.display, fontWeight: 800, fontSize: "1rem", color: marketingColors.gray900 }}>
                  Ticket {idx} - {event?.categories[key].category}
                </Typography>
                
                {user && (
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Checkbox 
                      name={idx} 
                      checked={forMe[idx]} 
                      onChange={handleForMe}
                      sx={{ 
                        color: marketingColors.p700,
                        '&.Mui-checked': {
                          color: marketingColors.p700,
                        },
                      }}
                    />
                    <Typography sx={{ fontFamily: marketingFonts.body, color: marketingColors.gray700 }}>Use my account details</Typography>
                  </Box>
                )}

                <TextField
                  fullWidth
                  required
                  id={`ticket-${idx}-name`}
                  label="Ticket Holder Name"
                  name={`ticket-${idx}-name`}
                  value={forMe[idx] ? user?.name : undefined}
                  disabled={forMe[idx]}
                  InputLabelProps={{ shrink: true }}
                  sx={modernFieldSx}
                />

                <TextField
                  fullWidth
                  required
                  type="email"
                  id={`ticket-${idx}-email`}
                  label="Ticket Holder Email"
                  name={`ticket-${idx}-email`}
                  value={forMe[idx] ? user?.email : undefined}
                  disabled={forMe[idx]}
                  InputLabelProps={{ shrink: true }}
                  sx={modernFieldSx}
                />

                <MuiPhoneNumber
                  fullWidth
                  required
                  id={`ticket-${idx}-mob`}
                  label="Ticket Holder Mobile"
                  name={`ticket-${idx}-mob`}
                  value={forMe[idx] ? user?.phoneNumber : undefined}
                  disableDropdown={Boolean(forMe[idx])}
                  InputProps={{ readOnly: Boolean(forMe[idx]) }}
                  InputLabelProps={{ shrink: true }}
                  defaultCountry={'eg'}
                  preferredCountries={['eg', 'us']}
                  countryCodeEditable={false}
                  disableAreaCodes
                  sx={phoneInputSx}
                />

                {event?.moreInfo.map((info) => (
                  <TextField
                    key={info}
                    fullWidth
                    required
                    id={`ticket-${idx}-${info}`}
                    label={info}
                    name={`ticket-${idx}-${info}`}
                    sx={modernFieldSx}
                  />
                ))}
              </Stack>
            </Paper>
          );
        }
      }
    }
    return items;
  };

  if (events?.isLoading) {
    return (
      <MarketingPage>
        <Box sx={{ ...centered_flex_box, py: 8 }}>
          <CircularProgress sx={{ color: marketingColors.p700 }} />
        </Box>
      </MarketingPage>
    );
  }

  const metaRowSx = {
    display: "flex",
    alignItems: "flex-start",
    gap: 1.5,
    "& .MuiSvgIcon-root": {
      fontSize: 22,
      color: "rgba(255,255,255,0.95)",
      mt: 0.15,
    },
  };

  return (
    <MarketingPage maxWidth="lg" sx={{ pt: { xs: 2, md: 3 } }}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Button
          component={RouterLink}
          to="/events"
          variant="text"
          sx={{
            mb: 2,
            px: 0,
            color: marketingColors.p700,
            fontFamily: marketingFonts.display,
            fontWeight: 700,
            textTransform: "none",
            "&:hover": { backgroundColor: "transparent", color: marketingColors.p600 },
          }}
        >
          ← Back to events
        </Button>

        <Typography sx={{ ...sectionLabelSx, mb: 1 }}>Event</Typography>

        <Grid container spacing={{ xs: 3, md: 4 }}>
          <Grid item xs={12} md={6}>
            <Paper 
              elevation={0}
              sx={{ 
                ...eventSurfacePaperSx,
                p: { xs: 2, sm: 2.5 },
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
              }}
            >
              <Image
                width="100%"
                height="auto"
                style={{ borderRadius: 12, display: "block" }}
                src={
                  event?.image ||
                  "https://tickit-media.s3.eu-central-1.amazonaws.com/images/Template.png"
                }
                alt="Event Poster"
              />
            </Paper>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper 
              elevation={0}
              sx={{ 
                ...eventSurfacePaperSx,
                p: 0,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
              }}
            >
              <Box
                sx={{
                  px: { xs: 2.5, sm: 3 },
                  py: { xs: 2.5, sm: 3 },
                  background: `linear-gradient(135deg, ${marketingColors.p900} 0%, ${marketingColors.p700} 55%, ${marketingColors.p500} 100%)`,
                  color: "#fff",
                  position: "relative",
                  "&::after": {
                    content: '""',
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    right: 0,
                    height: 1,
                    background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)",
                  },
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontFamily: marketingFonts.display,
                    fontWeight: 800,
                    letterSpacing: "-0.03em",
                    color: "#fff",
                    fontSize: { xs: "1.5rem", sm: "1.75rem" },
                    lineHeight: 1.2,
                    mb: 2,
                    textShadow: "0 1px 2px rgba(30, 5, 80, 0.35)",
                  }}
                >
                  {event?.title}
                </Typography>

                <Stack spacing={1.25}>
                  <Box sx={metaRowSx}>
                    <LocationOn />
                    <Typography sx={{ fontFamily: marketingFonts.body, color: "rgba(255,255,255,0.9)", lineHeight: 1.45 }}>
                      {event?.location}
                    </Typography>
                  </Box>
                  <Box sx={metaRowSx}>
                    <CalendarMonth />
                    <Typography sx={{ fontFamily: marketingFonts.body, color: "rgba(255,255,255,0.9)", lineHeight: 1.45 }}>
                      {event?.date ? moment(event.date).format("dddd, MMMM D, YYYY") : "—"}
                    </Typography>
                  </Box>
                  <Box sx={metaRowSx}>
                    <AccessTime />
                    <Typography sx={{ fontFamily: marketingFonts.body, color: "rgba(255,255,255,0.9)", lineHeight: 1.45 }}>
                      {event?.date ? moment(event.date).format("h:mm A") : "—"}
                    </Typography>
                  </Box>
                </Stack>
              </Box>

              <Box sx={{ p: { xs: 2.5, sm: 3 }, flex: 1, display: "flex", flexDirection: "column" }}>
                <Typography variant="body1" sx={{ fontFamily: marketingFonts.body, color: marketingColors.gray600, lineHeight: 1.75, mb: 3 }}>
                  {event?.description}
                </Typography>

                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  spacing={2}
                  sx={{ mt: "auto", "& .MuiButton-root": { width: { xs: "100%", sm: "auto" } } }}
                >
                  {event?.locationURL && (
                    <Button
                      variant="outlined"
                      startIcon={<DirectionsIcon />}
                      href={event?.locationURL}
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={eventOutlinedButtonSx}
                    >
                      Get Directions
                    </Button>
                  )}
                  {event?.public && !event?.byRequest &&
                    (event?.deadline
                      ? moment().isBefore(event?.deadline)
                      : moment().isBefore(event?.date)) && (
                    <Button
                      variant="contained"
                      startIcon={<AddShoppingCartIcon />}
                      onClick={handleShop}
                      sx={eventContainedButtonSx}
                    >
                      Add To Cart
                    </Button>
                  )}
                  {event?.public && event?.byRequest &&
                    (event?.deadline
                      ? moment().isBefore(event?.deadline)
                      : moment().isBefore(event?.date)) && (
                    <Button
                      variant="contained"
                      startIcon={<ScheduleSendIcon />}
                      onClick={handleShop}
                      sx={eventContainedButtonSx}
                    >
                      Request a ticket
                    </Button>
                  )}
                </Stack>
              </Box>
            </Paper>
          </Grid>
        </Grid>

        {/* Shopping/Request Form */}
        {shop && (
          <Box sx={{ mt: 5 }}>
            <Typography sx={{ ...sectionLabelSx, mb: 1.5 }}>Checkout</Typography>
          <Paper 
            elevation={0}
            sx={{ 
              ...eventFormSectionSx,
              p: { xs: 2, sm: 3 },
              boxShadow: "0 12px 40px rgba(70, 16, 155, 0.1)",
            }}
          >
            <Stack spacing={3}>
              <Typography sx={{ ...eventSectionTitleSx, fontSize: "1.35rem" }}>
                {!event.byRequest ? (event?.paymentMethod === "InstaPay" ? "Buy Tickets" : "Add Event To Cart") : "Request Event Ticket"}
              </Typography>

              {event.seatChart && (
                <Box sx={{ width: '100%', maxWidth: 600, mx: 'auto' }}>
                  <Image src={event.seatChart} preview />
                </Box>
              )}

              {!event.byRequest ? (
                <Box component="form" onSubmit={event?.paymentMethod === "InstaPay" ? handleTransfer : handleAddToCart}>
                  <Stack spacing={3}>
                    {/* Categories Selection */}
                    <Paper 
                      elevation={0}
                      sx={sectionCardSx}
                    >
                      <Typography sx={{ ...eventSectionTitleSx, mb: 2 }}>Select Tickets</Typography>
                      <Stack spacing={2}>
                        {generateCategories()}
                      </Stack>
                    </Paper>

                    {/* Ticket Holder Details */}
                    {Object.keys(amounts).some(key => amounts[key] > 0) && (
                      <Paper 
                        elevation={0}
                        sx={sectionCardSx}
                      >
                        <Typography sx={{ ...eventSectionTitleSx, mb: 2 }}>Ticket Holder Details</Typography>
                        <Stack spacing={2}>
                          {generateDetails()}
                        </Stack>
                      </Paper>
                    )}

                    {/* Payment Details for InstaPay */}
                    {event?.paymentMethod === "InstaPay" && (
                      <Paper 
                        elevation={0}
                        sx={sectionCardSx}
                      >
                        <Typography sx={{ ...eventSectionTitleSx, mb: 2 }}>Payment Details</Typography>
                        <Stack spacing={2}>
                          <Typography sx={{ fontFamily: marketingFonts.body, fontWeight: 700, color: marketingColors.gray900 }}>Pay To:</Typography>
                          {event?.paymentAddress?.map((add, index) => (
                            <Typography key={index} variant="body2" sx={{ fontFamily: marketingFonts.body, color: marketingColors.gray600 }}>
                              {add}
                            </Typography>
                          ))}
                          
                          <ReactFileReader multipleFiles={false} handleFiles={handleAddReceipt} fileTypes={[".jpeg", ".jpg", ".png", ".svg"]}>
                            <Button 
                              variant="outlined" 
                              startIcon={<Upload />}
                              sx={eventOutlinedButtonSx}
                            >
                              Upload Receipt
                            </Button>
                          </ReactFileReader>

                          {receipt && (
                            <Chip 
                              label={receipt.name} 
                              onDelete={handleDeleteReceipt}
                              sx={{ 
                                color: marketingColors.p700,
                                fontFamily: marketingFonts.body,
                                fontWeight: 600,
                                backgroundColor: '#fff',
                                border: `1px solid ${marketingColors.p300}`,
                              }}
                            />
                          )}

                          <TextField
                            fullWidth
                            required
                            id="paymentUser"
                            label="Payment Method Username"
                            name="paymentUser"
                            variant="outlined"
                            sx={modernFieldSx}
                          />
                        </Stack>
                      </Paper>
                    )}

                    {/* Summary and Submit */}
                    <Paper 
                      elevation={0}
                      sx={sectionCardSx}
                    >
                      <Grid container alignItems="center" spacing={2}>
                        <Grid item xs={12} sm={6}>
                          <Typography sx={{ ...eventSectionTitleSx, fontSize: "1rem", mb: 0.5 }}>Total</Typography>
                          <Typography variant="h5" sx={{ fontFamily: marketingFonts.display, fontWeight: 800, color: marketingColors.p700 }}>
                            {total} EGP
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} sx={{ textAlign: { xs: 'left', sm: 'right' } }}>
                          <Button
                            type="submit"
                            variant="contained"
                            startIcon={event?.paymentMethod === "InstaPay" ? <AccountBalance /> : <AddShoppingCartIcon />}
                            sx={{ 
                              ...eventContainedButtonSx,
                              width: { xs: '100%', sm: 'auto' },
                            }}
                          >
                            {event?.paymentMethod === "InstaPay" ? "Buy Now" : "Add to Cart"}
                          </Button>
                        </Grid>
                      </Grid>
                    </Paper>
                  </Stack>
                </Box>
              ) : (
                <Box component="form" onSubmit={handleRequestTicket}>
                  <Stack spacing={3}>
                    {/* Category Selection */}
                    <Paper 
                      elevation={0}
                      sx={sectionCardSx}
                    >
                      <Typography sx={{ ...eventSectionTitleSx, mb: 2 }}>Select Category</Typography>
                      <FormControl fullWidth required error={Boolean(categoryError)}>
                        <Select
                          value={category}
                          onChange={handleCategoryChange}
                          displayEmpty
                          sx={modernFieldSx}
                        >
                          <MenuItem value="" disabled sx={{ color: '#6c6c6c' }}>
                            Select Category
                          </MenuItem>
                          {event?.categories?.map((cat) => (
                            cat.available === "true" && (
                              <MenuItem key={cat.category} value={cat.category} sx={{ color: '#1f1f1f' }}>
                                {cat.category} - {cat.price} EGP
                              </MenuItem>
                            )
                          ))}
                        </Select>
                        {categoryError && <FormHelperText>{categoryError}</FormHelperText>}
                      </FormControl>
                    </Paper>

                    {/* Ticket Holder Details */}
                    <Paper 
                      elevation={0}
                      sx={sectionCardSx}
                    >
                      <Typography sx={{ ...eventSectionTitleSx, mb: 2 }}>Ticket Holder Details</Typography>
                      <Stack spacing={2}>
                        {user && (
                          <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Checkbox 
                              name="0" 
                              checked={forMe[0]} 
                              onChange={handleForMe}
                              sx={{ 
                                color: marketingColors.p700,
                                '&.Mui-checked': {
                                  color: marketingColors.p700,
                                },
                              }}
                            />
                            <Typography sx={{ fontFamily: marketingFonts.body, color: marketingColors.gray700 }}>Use my account details</Typography>
                          </Box>
                        )}
                        
                        <TextField
                          fullWidth
                          required
                          id="ticket-0-name"
                          label="Ticket Holder Name"
                          name="ticket-0-name"
                          value={forMe[0] ? user?.name : undefined}
                          disabled={forMe[0]}
                          InputLabelProps={{ shrink: true }}
                          sx={modernFieldSx}
                        />

                        <TextField
                          fullWidth
                          required
                          type="email"
                          id="ticket-0-email"
                          label="Ticket Holder Email"
                          name="ticket-0-email"
                          value={forMe[0] ? user?.email : undefined}
                          disabled={forMe[0]}
                          InputLabelProps={{ shrink: true }}
                          sx={modernFieldSx}
                        />

                        <MuiPhoneNumber
                          fullWidth
                          required
                          id="ticket-0-mob"
                          label="Ticket Holder Mobile"
                          name="ticket-0-mob"
                          value={forMe[0] ? (user?.phoneNumber || "") : ticketPhone}
                          onChange={(value) => {
                            if (forMe[0]) return;
                            setTicketPhone(value || "");
                          }}
                          disableDropdown={Boolean(forMe[0])}
                          InputProps={{ readOnly: Boolean(forMe[0]) }}
                          InputLabelProps={{ shrink: true }}
                          defaultCountry={'eg'}
                          preferredCountries={['eg', 'us']}
                          countryCodeEditable={false}
                          disableAreaCodes
                          sx={phoneInputSx}
                        />

                        {event?.moreInfo.map((info) => (
                          <TextField
                            key={info}
                            fullWidth
                            required
                            id={`ticket-0-${info}`}
                            label={info}
                            name={`ticket-0-${info}`}
                            sx={modernFieldSx}
                          />
                        ))}
                      </Stack>
                    </Paper>

                    {/* Summary and Submit */}
                    <Paper 
                      elevation={0}
                      sx={sectionCardSx}
                    >
                      <Grid container alignItems="center" spacing={2}>
                        <Grid item xs={12} sm={6}>
                          <Typography sx={{ ...eventSectionTitleSx, fontSize: "1rem", mb: 0.5 }}>Total</Typography>
                          <Typography variant="h5" sx={{ fontFamily: marketingFonts.display, fontWeight: 800, color: marketingColors.p700 }}>
                            {total} EGP
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} sx={{ textAlign: { xs: 'left', sm: 'right' } }}>
                          <Button
                            type="submit"
                            variant="contained"
                            startIcon={<SendIcon />}
                            sx={{ 
                              ...eventContainedButtonSx,
                              width: { xs: '100%', sm: 'auto' },
                            }}
                          >
                            Request Ticket
                          </Button>
                        </Grid>
                      </Grid>
                    </Paper>
                  </Stack>
                </Box>
              )}
            </Stack>
          </Paper>
          </Box>
        )}

        {/* Terms and Conditions */}
        {event?.terms && (
          <Paper 
            elevation={0}
            sx={{ 
              ...eventSurfacePaperSx,
              p: 0,
              mt: 5,
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                height: 4,
                background: `linear-gradient(90deg, ${marketingColors.p700}, ${marketingColors.p400})`,
              }}
            />
            <Box sx={{ p: 3 }}>
            <Typography sx={{ ...eventSectionTitleSx, mb: 2 }}>Terms and Conditions</Typography>
            <Typography variant="body1" sx={{ fontFamily: marketingFonts.body, color: marketingColors.gray600, lineHeight: 1.75 }}>
              {event?.terms}
            </Typography>
            </Box>
          </Paper>
        )}
      </motion.div>
    </MarketingPage>
  );
};

const mapStateToProps = (state) => ({
  events: state?.events,
  event: state?.events?.results,
  user: state?.auth?.user,
});

const mapDispatchToProps = { getEvent, addToCart, requestTicket, checkoutTransfer };

export default connect(mapStateToProps, mapDispatchToProps)(SingleEvent);
